import { Controller } from '@hotwired/stimulus'
import { mapsReady } from '../utils/maps'

/**
 * Карта на странице клуба: точка клуба с его логотипом.
 *
 * @extends {Controller}
 */
export default class ClubLocationMapController extends Controller {
  static targets = ['canvas']

  static values = {
    latitude: Number,
    longitude: Number,
    title: String,
    zoom: { type: Number, default: 15 },
    pinImage: String
  }

  #map = null

  async connect() {
    const { maplibregl, createMap } = await mapsReady()
    if (this.#map || !this.element.isConnected) return

    const position = [this.longitudeValue, this.latitudeValue]

    // Снимок страницы в кеше Turbo хранит разметку прошлой карты: без очистки новая легла бы поверх неё вторым набором кнопок.
    this.canvasTarget.replaceChildren()

    try {
      this.#map = createMap(this.canvasTarget, {
        center: position,
        zoom: this.zoomValue
      })
    } catch {
      // MapLibre бросает исключение, если в браузере нет WebGL2.
      this.element.hidden = true
      return
    }

    this.#map.addControl(new maplibregl.FullscreenControl())
    this.#map.addControl(
      new maplibregl.NavigationControl({ showCompass: false }),
      'bottom-right'
    )

    new maplibregl.Marker({ element: this.#buildMarker() })
      .setLngLat(position)
      .addTo(this.#map)
  }

  disconnect() {
    this.#map?.remove()
    this.#map = null
  }

  #buildMarker() {
    const marker = document.createElement('div')
    marker.className = 'logo-marker'
    marker.setAttribute('aria-label', this.titleValue)

    if (this.hasPinImageValue) {
      const image = document.createElement('img')
      image.src = this.pinImageValue
      image.alt = ''
      image.width = 56
      image.height = 56
      marker.append(image)
    }

    return marker
  }
}
